import engine from 'store/src/store-engine';
import localStorage from 'store/storages/localStorage';
import cookieStorage from 'store/storages/cookieStorage';
import defaultsPlugin from 'store/plugins/defaults';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {sections} from '../sectionConfig';
import {getFamilyConfig} from '../familyConfig';
import {setLocale} from '../components/configuratorApp';
import {selectSectionConfig} from '../selectors';

const storage = engine.createStore(
	[localStorage, cookieStorage],
	[defaultsPlugin]
);

const statusInitialState = {
	formatVersion: 30,
	versionNotice: null,
	currentProjectKey: null,

	embed: false,
	family: '',
	lang: '',
	region: '',
	mode: '',
	media: '',
	features: {
		relux: false,
		shortArticleNumber: false
	},

	productFamily: '',

	initialized: false,
	dashboardActive: false,
	settingsActive: false,
	specsheetActive: false,
	downloadPanelSpecsheetActive: false,
	specsheetType: 'family',
	forceOverview: false,
	hideOverview: false,
	skipConfigurationEngine: true,

	modalActive: false,
	modalContent: null,
	modalTitle: null,

	explainActive: false,
	desire: null,
	cause: null,
	solution: null,
	constraints: null,

	visualActive: false,
	debug: false,
	debugShowAll: false,
	debugAeto: false,
	componentView: false,
	usedSections: false,

	host: null,
	baseUrl: null,
	apiUrl: null,
	channel: null,
	expressUrl: null,
	engineUrl: null,
	engine2Url: null,
	authUrl: null,
	pimUrl: null,
	priceUrl: null,
	shortNumberUrl: null,
	shortArticleNumberUrl: null,
	epimAssetsUrl: null,
	pvgisUrl: null,
	specsheetUrl: null,
	shortKey: null,
	originalKey: null,
	dataManager: null,
	routeUid: null,

	productImagesUrl: null,

	currentSection: '',
	currentSectionIndex: 0,
	cameFromSections: false,

	inViewport: false,

	numbers: {
		majorNumbers: [1000, 3000, 5000, 9000, 11000],
		intermediateNumbers: [
			[1300, 1600, 1900, 2500],
			[4000],
			[],
			[9700, 10600]
		]
    },

};
export const statusSlice = createSlice({
	name: 'status',
	initialState: statusInitialState,
	reducers: {
		duplicate: (state, action) => {
			// TODO: implement duplicate
			console.log('duplicate');
			/*
			set


			dataManager.setCurrentProjectKey(key);
			state.currentProjectKey = projectKey;

			const currentProject = dataManager.getCurrentProject();

			const lastPersistedBy = currentProject?.lastPersistedBy ?? 'External';
			const projectModelId = currentProject?.productModelId ?? 'Column';
			//const region = currentProject?.region ?? this.dataAttr().get('region') ?? 'int';
			//const lang = currentProject?.lang ?? this.dataAttr().get('lang') ?? 'de';

			updateUrl(state.baseUrl, state.media, key, true);

			//state.lang = lang;
			//state.region = region;
			state.dataKey = key;
			state.shortKey = key.substr(0, 8);
			state.productModel = projectModelId;
			console.log(state);
			*/
		},
		setStatus: (state, action) => {
			state = Object.assign(state, action.payload);
		},
		setInitialized: (state, action) => {
			state.initialized = action.payload.initialized;
		},

		setModalActive: (state, action) => {
			state.modalActive = action.payload.modalActive;
			state.modalContent = action.payload.modalActive ? action.payload.content.replaceAll('␍', '\n') : null;
			state.modalTitle = action.payload.modalActive ? action.payload.title : null;
		},
		setExplainActive: (state, action) => {
			state.desire = action.payload.desire ?? null;
			state.cause = action.payload.cause ?? null;
			state.solution = action.payload.solution ?? null;
			state.causedBy = action.payload.causedBy ?? null;
			state.causedByRules = action.payload.causedByRules ?? null;
			state.explainActive = action.payload.explainActive;
		},
		setDownloadPanelSpecsheetActive: (state, action) => {
			if (action.payload.specsheetType !== null) {
				state.specsheetType = action.payload.specsheetType;
			}
			state.downloadPanelSpecsheetActive = action.payload.downloadPanelSpecsheetActive;
			const mainElements = document.getElementsByClassName('slx-main');
			console.log(mainElements);
			if (mainElements.length > 0) {
				mainElements[0].classList.toggle('slx-js-covered', state.downloadPanelSpecsheetActive);
			}
		},
		setDebug: (state, action) => {
			state.debug = action.payload.debug;
		},
		setDebugShowAll: (state, action) => {
			state.debugShowAll = action.payload.debugShowAll;
		},
		setDebugAeto: (state, action) => {
			state.debugAeto = action.payload.debugAeto;
		},
		setComponentView: (state, action) => {
			state.componentView = action.payload.componentView;
		},
		setSettingsActive: (state, action) => {
			state.settingsActive = action.payload.settingsActive;
		},
		toggleSettingsActive: (state, action) => {
			state.settingsActive = !state.settingsActive;
		},
		setLang: (state, action) => {
			state.lang = action.payload.lang;
			if (state.lang) {
				setLocale(state.lang);
			}
		},
		setRegion: (state, action) => {
			state.region = action.payload.region;
		},
		setFamily: (state, action) => {
			state.family = action.payload.family;
			state.forceOverview = getFamilyConfig(state.family).forceOverview;
			state.hideOverview = getFamilyConfig(state.family).hideOverview;

			state.productFamily = getFamilyConfig(state.family).defaultProductFamily;
			state.skipConfigurationEngine = getFamilyConfig(state.family).skipConfigurationEngine;
		},
		setEmbed: (state, action) => {
			state.embed = action.payload.embed;
		},
		setMedia: (state, action) => {
			// force overview, when configured
			if (state.forceOverview && action.payload.media === 'sections') {
				state.media = 'overview';
			} else {
				state.media = action.payload.media;
			}
			state.dashboardActive = state.media === 'overview';
			state.specsheetActive = state.media === 'specsheet';
			state.visualActive = state.media === 'sections';
			if (state.media === 'sections') {
				state.usedSections = true;
			}
		},
		setKey: (state, action) => {
			state.dataKey = action.payload.key;
			state.shortKey = action.payload.key.substr(0, 8);
		},
		setOriginalKey: (state, action) => {
			state.originalKey = action.payload.key;
		},
		firstSection: (state, action) => {
			const sectionConfig = selectSectionConfig(state);
			state.currentSection = sectionConfig[0].id;
		},
		setSection: (state, action) => {
			state.currentSection = action.payload.currentSection;
		},
		setCameFromSections: (state, action) => {
			state.cameFromSections = action.payload;
		},
		nextSection: (state, action) => {
			//const currentIndex = sectionConfig.findIndex(section => section.id === state.currentSection);
			//const newIndex = currentIndex < sectionConfig.length - 1 ? currentIndex + 1 : sectionConfig.length - 1;
			//state.currentSection = sectionConfig[newIndex].id;
		},
		previousSection: (state, action) => {
			const sectionConfig = action.payload.sectionConfig;
			const currentIndex = sectionConfig.findIndex(section => section.id === state.currentSection);
			const newIndex = currentIndex > 0 ? currentIndex - 1 : 0;
			state.currentSection = sectionConfig[newIndex].id;
		},

		setMajorNumbers: (state, action) => {
			if (state.numbers?.majorNumbers) {
				state.numbers.majorNumbers = action.payload;
			}
		},

		setIntermediateNumbers: (state, action) => {
			if (state.numbers?.intermediateNumbers) {
				state.numbers.intermediateNumbers = action.payload;
			}
		},

		showVersionNotice: (state, action) => {
			state.showVersionNotice = action.payload.active;
			state.versionNotice = action.payload;
		},
	},
	extraReducers: (builder) => {
	}
});

export const {
	setSection,
	firstSection,
	nextSection,
	previousSection,
	setEmbed,
	setStatus,
	setFamily,
	setLang,
	setRegion,
	setMedia,
	setKey,
	setOriginalKey,
	setSectionConfig,
	setModalActive,
	setExplainActive,
	setDebug,
	setDebugShowAll,
	setDebugAeto,
	setComponentView,
	setIntermediateNumbers,
	setMajorNumbers,
	showVersionNotice,
	setSettingsActive,
	toggleSettingsActive,
	duplicate,
	setDownloadPanelSpecsheetActive,
	setInitialized
} = statusSlice.actions;


export default statusSlice.reducer;
